
import { Link } from 'react-router-dom';

export default function CTA() {
  return (
    <section className="py-24 bg-gradient-to-br from-emerald-600 to-teal-700">
      <div className="max-w-5xl mx-auto px-6 lg:px-8 text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
          Comienza tu Solicitud Hoy
        </h2>
        <p className="text-xl text-emerald-50 mb-12 max-w-2xl mx-auto leading-relaxed">
          Proceso 100% en línea, seguro y confidencial. Obtén una respuesta preliminar en 24-48 horas.
        </p>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
          <Link to="/solicitar-credito" className="px-8 py-4 bg-white text-emerald-700 text-base font-semibold rounded-lg hover:bg-slate-50 transition-all shadow-lg hover:shadow-xl whitespace-nowrap">
            Solicitar Crédito Ahora
          </Link>
          <Link to="/simulador" className="px-8 py-4 bg-emerald-700 text-white text-base font-semibold rounded-lg hover:bg-emerald-800 transition-all border border-white/30 whitespace-nowrap">
            Simular mi Crédito
          </Link>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-8 pt-8 border-t border-white/20">
          <div className="flex items-center space-x-2">
            <i className="ri-time-fill text-white text-xl"></i>
            <span className="text-sm text-white">Respuesta en 24-48h</span>
          </div>
          <div className="flex items-center space-x-2">
            <i className="ri-shield-check-fill text-white text-xl"></i>
            <span className="text-sm text-white">100% Seguro</span>
          </div>
          <div className="flex items-center space-x-2">
            <i className="ri-lock-fill text-white text-xl"></i>
            <span className="text-sm text-white">Datos Protegidos</span>
          </div>
          <div className="flex items-center space-x-2">
            <i className="ri-customer-service-fill text-white text-xl"></i>
            <span className="text-sm text-white">Asesoría Personalizada</span>
          </div>
        </div>
      </div>
    </section>
  );
}
